// https://github.com/zeit/next.js/issues/1627
export const NEXT_PATHS = ['/_next', '/_webpack/', '/__webpack_hmr', '/static/']

export const FE_CORE_STATIC_PATH = '/fe-core/static'

export const NEW_RELIC_LICENSE_KEY = process.env.NEW_RELIC_LICENSE_KEY
export const NEW_RELIC_APP_NAME = process.env.NEW_RELIC_APP_NAME
export const ROLLBAR_ACCESS_TOKEN_SERVER =
  process.env.ROLLBAR_ACCESS_TOKEN_SERVER

export const SERVER_PATHS = NEXT_PATHS.concat([
  '/api',
  '/favicon.ico',
  '/robots.txt'
])

export const isServerPath = (req) =>
  SERVER_PATHS.some((path) => req.url.startsWith(path))

export const BANNER = `
       _,gggggg,_
     ,d8P""d8P"Y8b,           8I          8I  ,dPYb,
    ,d8'   Y8   "8b,dP        8I          8I  IP' Yb
    d8'     Ybaaad88P'        8I          8I  I8  8I
    8P        """"Y8          8I          8I  I8  8'
    8b            d8    ,gggg,8I    ,gggg,8I  I8 dP   ,ggg,
    Y8,          ,8P   dP"  "Y8I   dP"  "Y8I  I8dP   i8" "8i
     Y8,        ,8P'  i8'    ,8I  i8'    ,8I  I8P    I8, ,8I
      Y8b,,__,,d8P'  ,d8,   ,d8b,,d8,   ,d8b,,d8b,_   YbadP'
        "Y8888P"'    P"Y8888P"'Y8P"Y8888P"'Y88P'"Y88888P"Y888

`

export const DEFAULT_BREAKPOINTS = {
  mobile: 0,
  tablet: 720,
  desktop: 1024
}

export const DEFAULT_LOCALE = 'en_SG'

export const isBrowser = (): boolean => typeof window !== 'undefined'
export const origin = (port) => (req) => {
  if (isBrowser()) {
    const { protocol, hostname, port } = window.location
    return `${protocol}//${hostname}${port ? ':' + port : ''}`
  }
  return req ? `http://localhost:${port}` : ''
}

export const APP_NAME = process.env.APP_NAME
export const DEV = process.env.NODE_ENV !== 'production'

export const APP_NAME_PATH = APP_NAME ? `/__${APP_NAME}` : ''
// TODO: try to look into specify env on npm install
export const appResource = (path: string): string =>
  `${APP_NAME_PATH}/static${path || ''}`
export const coreResource = (path: string): string =>
  `${APP_NAME_PATH}${FE_CORE_STATIC_PATH}${path || ''}`
